import styled from 'styled-components'

export const Container = styled.div`
  display: flex;

  #printable {
    table {
      font-size: 12px;
      border: 1px solid #454545;
      margin: 0px;
      min-width: 90%;

      tr {
        border: 1px solid #454545;
      }

      td,
      th {
        padding: 4px;
      }

      /* Linha de totais: cada célula em uma extremidade da linha.
         É tabela, então não há flex/space-between — o efeito vem de
         dividir a largura ao meio e alinhar cada td para um lado. */
      tr.FolhaLaboratorio__totais {
        td {
          width: 50%;
        }

        td:first-child {
          text-align: left;
        }

        td:last-child {
          text-align: right;
        }
      }
    }
  }

  @media print {
    @page {
      size: A4;
    }
    body {
      visibility: hidden;
    }

    table {
      page-break-inside: auto;
    }
    thead {
      padding: 10px;
    }

    tfoot {
    }

    #printable {
      margin: 40px;
    }

    #printable,
    #printable * {
      visibility: visible;
    }
  }
`
